export default __webpack_public_path__ + "static/media/anchor-grey.b5ff4ab8.jpg";